import { View } from 'react-native'
import { Check } from 'lucide-react-native'
import { colors } from '@chillout/core'

export function SuccessIcon() {
  return (
    <View className="h-16 w-16 items-center justify-center rounded-full bg-success/10">
      <Check size={32} color={colors.success} strokeWidth={1.8} />
    </View>
  )
}
